import styled from "styled-components";

const HeightBar = styled.div`
  display: inline-block;
  height: 14px;
  transform: translateY(1px);
  position: absolute;
  top: 1px;
  left: 0;
  background-color: rgba(32, 136, 226, 0.24);
  width: ${({ height }) => (100 / 5) * height + "px"};

  @media only screen and (min-width: 415px) {
    height: 16px;
  }
`;

export default HeightBar;
